import { render } from "./ChartsDemo.vue?vue&type=template&id=6ac56666"
import script from "./ChartsDemo.vue?vue&type=script&lang=js"
export * from "./ChartsDemo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__